export default "__VITE_ASSET__8d3077ea__"